import React, { useState } from "react";
import "./NRFilingPending.css";
import CustomTable from "../../Components/CustomTable/CustomTable";
import CustomDropdown from "../../../Components/CustomDropdown/CustomDropdown";
import { capitalize, getStatusColor } from "../../../helpers/helpers";
import CommentsHistory from "../Components/CommentsHistory/CommentsHistory";
import ClientDetails from "../Components/ClientDetails/ClientDetails";

const data = [];

const handleRowClick = (rowData) => {
  console.log("Row clicked", rowData);
};
const NRFilingPending = () => {
  const [modal, setModal] = useState("");
  const columns = [
    { key: "serial_no", title: "Sl. No" },
    { key: "client_name", title: "Client Name" },
    { key: "email", title: "Email" },
    {
      key: "comments",
      title: "Comments",
      render: (rowData) => (
        <div className="nrfilingpending__cmntscol_wrap">
          <div>{rowData?.comments}</div>
          <button
            className="nrfilingpending__cmntshistory"
            onClick={() => setModal("commentsHistory")}
          >
            View History
          </button>
        </div>
      ),
    },
    { key: "date_and_time", title: "Date and Time" },
    { key: "time_zone", title: "Timezone" },
    { key: "file_no", title: "File#" },
    {
      key: "status",
      title: "Status",
      render: (rowData) => (
        <button
          className="nrfilingpending__table_btn1"
          style={{
            backgroundColor: getStatusColor(rowData?.status),
            pointerEvents: "none",
          }}
        >
          {capitalize(rowData?.status)}
        </button>
      ),
    },
    {
      key: "action",
      title: "Action",
      render: (rowData) => (
        <button
          className="nrfilingpending__table_btn1"
          onClick={() => setModal("clientDetails")}
        >
          View
        </button>
      ),
    },
  ];
  return (
    <div>
      <CommentsHistory
        open={modal === "commentsHistory"}
        handleClose={() => setModal(false)}
      />
      <ClientDetails
        open={modal === "clientDetails"}
        handleClose={() => setModal(false)}
      />
      <div className="admindash__efiling_header">
        <div className="admindash__efiling_headerleft">
          <div className="admindash__efiling_hfinputbox">
            <input
              className="admindash__efiling_hfinputfield"
              placeholder="Search by Name or Email or Phone or File No"
            />
            <button className="admindash__efiling_hfsearchbtn">Search</button>
          </div>
        </div>
        <div className="admindash__efiling_headerright">
          <div className="admindash__efiling_hrbox">
            <div className="admindash__efiling_hrboxtxt">
              Please select the tax year:
            </div>
            <div className="admindash__efiling_hrboxdropwrap">
              <CustomDropdown
                options={["2023"]}
                selectedLabel="2023"
                onSelect={(option) => {}}
                customStyles={{ height: "56px", borderColor: "transparent" }}
              />
            </div>
          </div>
        </div>
      </div>
      <br />
      <CustomTable
        columns={columns}
        data={data}
        onRowClick={handleRowClick}
        itemsPerPage={5}
      />
    </div>
  );
};

export default NRFilingPending;
